import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import logo from "../../landing_website/assets/images/logo.png";
import MenuIcon from "@mui/icons-material/Menu";
export default function HeaderLandingPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  const [isClassAdded, setIsClassAdded] = useState(false);
  const handleButtonClick = () => {
    setIsClassAdded((prevIsClassAdded) => !prevIsClassAdded);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <>
      <div className={isScrolled ? "landing_header fixed-header " : " landing_header"}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <nav>
                <div className="landing_nav_flex">
                  <div className="landing_navbar_brand">
                    <div className="landing_navbar_logo">
                      <Link to="/home">
                        <img src={logo} alt="logo" />
                      </Link>
                    </div>
                    <div className="menubar">
                      <Link to="" onClick={handleButtonClick}>
                        <MenuIcon />
                      </Link>
                    </div>
                  </div>
                  <div className={`landing_navbar_menu ${isClassAdded ? "sidebarmobilemenu" : ""}`}>
                    <div className="mobilemenu">
                      {/* 
                     <Link to="" className='close closemenubar' onClick={handleButtonClick}>
                     X</Link> */}
                      <ul>
                        <li className=" ">
                          <Link to="/landing-home" className="main-menu" onClick={() => scrollToSection("Home")}>
                            Home
                          </Link>
                        </li>
                        <li className=" ">
                          <Link to="#" className="main-menu" onClick={() => scrollToSection("Features")}>
                            Features
                          </Link>
                        </li>
                        <li className=" ">
                          <Link to="/articles" className="main-menu" onClick={() => scrollToSection("Features")}>
                            Articles
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="navbar-button">
                    <Link to="/login">
                      <button type="button" className="btn btn-default">
                        Login
                      </button>
                    </Link>
                    <Link to="/sign-up">
                      <button type="button" className="btn btn-primary">
                        Sign Up
                      </button>
                    </Link>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
